import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import './login.css'
import { attemptLogin, loginSuccess } from "../../actions/loginAction";
import { deleteCookie, getCookie, setCookie, setCookieLogin } from "../../helpers/Cookie";
import Utils from "../../helpers/Utils";
import { fetchLoginPageData } from "../../api/loginApi";
import { Helmet } from "react-helmet";
import ListSkeleton from "../common/Skeletons/ListSkeleton";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { CUSTOM_DOMAIN_ACTIVE } from "../../helpers/CoreConstant";
import OtpFormForLogin from "./OtpFormForLogin";
import { Checkbox, FormControlLabel, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "underline",
    color: (props) => props.agencyTextColor || "var(--dark_blue)",
    fontWeight:600,
     fontSize:'14px !important'
  },
  checkbox: {
    color: (props) => props.agencyTextColor || "var(--dark_blue)",
    "&.Mui-checked": {
      color: (props) => props.agencyTextColor || "var(--dark_blue)",
    },
  },

    errorText: {
    fontSize: "12px",
    color: "var(--red)",
    marginLeft: "12px",
  },
}));

const Login = props => {

    const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [agencyId, setAgencyId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState({});
    const [userApiKeyForOtp, setUserApiKeyForOtp] = useState('');
    const [pageInfo, setPageInfo] = useState({
        logo: '',
        favIcon: '',
        agencyName: '',
        agencyAccentColor: '',
        agencyThemeColor: '',
        agencyTextColor: '',
        privacyPolicy: '',
        termsAndConditions: ''
    });
    const [textTypeChange, setTextTypeChange] = useState(false);

  const [errors, setErrors] = useState({});
  const [isPolicyAndConditionChecked, setIsPolicyAndConditionChecked] = useState(true);
  const trialAgencyIds = [1, 236];

    useEffect(() => {
        //Check access token
        const accessToken = getCookie(process.env.REACT_APP_ACCESS_TOKEN);
        if (accessToken.length !== 0) {
            let redirect_url = checkAddressUrl()
            if (redirect_url !== undefined && redirect_url !== null) {
                history.push(redirect_url);
            } else {
                history.push('/');
            }
        }
        //Fetch agency id from url
        fetchLoginPageData().then(response => {
            setLoading(false);

            if (response.data.status) {

                if (response.data.data.customDomainActive === CUSTOM_DOMAIN_ACTIVE && response.data.data.domainPrefix === window.location.host && response.data.data.domainPrefix !== response.data.data.customDomain) {
                    window.location.replace(window.location.href.replace(response.data.data.domainPrefix, response.data.data.customDomain));
                } else {
                    setAgencyId(response.data.data.agencyId);
                    setPageInfo({
                        ...pageInfo,
                        logo: response.data.data.agencyLogo,
                        favIcon: response.data.data.favIcon,
                        agencyName: response.data.data.agencyName,
                        agencyAccentColor: response.data.data.agencyAccentColor,
                        agencyThemeColor: response.data.data.agencyThemeColor,
                        agencyTextColor: response.data.data.agencyTextColor,
                        privacyPolicy: response.data.data.privacyPolicy,
                        termsAndConditions: response.data.data.termsAndConditions,
                    });
                }
            } else {
                window.showNotification("ERROR", "Whoops! something went wrong. Please reload the page")
            }
        }).catch((error) => {
            if (window.showNotification) {
                window.showNotification("ERROR", "Whoops! something went wrong.")
            }
        });

    }, [props.apiKey]);

    const validateFields = () => {
        const newErrors = {};

        if (!isPolicyAndConditionChecked) {
        newErrors.isPolicyAndConditionChecked =
            "You must agree to the Terms and Privacy Policy.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
  };

    const handleSubmit = e => {
        e.preventDefault();

        if (!validateFields()) {
            return;
        }

        let formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        formData.append('agencyId', process.env.REACT_APP_PRODUCTION_MODE === 'true' ? agencyId : 236);

        props.attemptLogin(formData, loginResponse);
    }

    const loginResponse = response => {
        let mailTo = '';
        if (response.agencyEmail !== undefined) {
            mailTo = "mailto:" + response.agencyEmail;
        }

        if (response.status === 'success') {
            deleteCookie(process.env.REACT_APP_ACCESS_PARENT_TOKEN);
            setCookie(process.env.REACT_APP_ACCESS_TOKEN, response.api_key, process.env.REACT_APP_ACCESS_TOKEN_VALIDITY);
            setCookieLogin(process.env.REACT_APP_ACCOUNT_DATA, JSON.stringify(response.accountData), process.env.REACT_APP_ACCESS_TOKEN_VALIDITY);
            if (response.accountData.userId) {
                const channel = new BroadcastChannel('pypepro-channel');

                // Send a message to other tabs
                channel.postMessage({ "action": "reload-page-" + response.accountData.userId, "link": "RELOAD" });

            }
            props.loginSuccess(response.api_key);
        } else if (response.status === 'invalid_credentials') {
            setLoading(false);
            setError({ message: <>Your email or password is incorrect. If you don't remember your password, <a href={"/password-reset"}>reset it now.</a></> })
        } else if (response.status === 'invalid_email') {
            setLoading(false);
            setError({ message: <>The email you entered is incorrect.</> })
        } else if (response.status === 'invalid_password') {
            setLoading(false);
            setError({ message: <>The password you entered is incorrect. If you don't remember your password, <a href={"/password-reset"}>reset it now.</a></> })
        } else if (response.status === 'validation-error') {
            setLoading(false);
            setError({ message: response.message });
        } else if (response.status === 'status_pending') {
            setLoading(false);
            setError({ message: <>Your account is currently in pending mode. Please contact our team at <a href={mailTo}>{response.agencyEmail}</a> to activate your account.</> });
        } else if (response.status === 'status_inactive') {
            setLoading(false);
            setError({ message: <>Your account is suspended, to know more please contact with our <a href='https://help.salespype.com/'>support</a></> });
        } else if (response.status === 'otp_needed') {
            setLoading(false);
            setUserApiKeyForOtp(response.api_key);
        } else {
            setLoading(false);
            Utils.showNotification('Whoops! Something went wrong. Please try again.');
        }
    }

    const checkAddressUrl = () => {
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get('redirect_url');
    }

    const classes = useStyles({ agencyThemeColor: pageInfo.agencyThemeColor, agencyTextColor: pageInfo.agencyTextColor, accentColor: pageInfo.agencyAccentColor });
    
    return (
        <div className="h__100__percent" style={{ background: pageInfo.agencyThemeColor, color: pageInfo.agencyTextColor }}>
            <Helmet>
                <link rel="icon" href={pageInfo.favIcon} />
                <title>{`Login | ${pageInfo.agencyName}`}</title>
                <meta name="description" content="All-In-One Sales & Marketing Platform" />
                <meta name="keywords" content={`CRM, Automation, Sales, Marketing, ${pageInfo.agencyName}`} />
                <meta name="author" content={pageInfo.agencyName} />
            </Helmet>
            {loading &&
                <div className="container h__100__percent">
                    <div className="main_logo" style={{ margin: '0 auto', width: '250px' }}>
                        <ListSkeleton width={250} height={100} />
                    </div>
                    <div className="main_logo" style={{ margin: '0 auto', width: '300px' }}>
                        <ListSkeleton width={300} />
                    </div>
                    <br />
                    <div className="main_logo" style={{ margin: '0 auto', width: '500px' }}>
                        <ListSkeleton width={500} number={5} />
                    </div>
                    <br />
                    <div className="main_logo" style={{ margin: '0 auto', width: '500px' }}>
                        <ListSkeleton width={500} />
                    </div>
                    <div className="main_logo" style={{ margin: '0 auto', width: '250px' }}>
                        <ListSkeleton width={250} />
                    </div>
                </div>
            }
            {!loading &&
                userApiKeyForOtp === '' ?
                <div className="container h__100__percent">
                    <div className="row h__100__percent">
                        <div className="center-align h__100__percent singin_content">
                            {/* <div 
                                style={{
                                    width:'100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    backgroundColor: '#c9564d',
                                    color: '#fff',
                                    border: '1px solid #c9564d',
                                    borderRadius: '6px',
                                    padding: '16px 20px',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '16px',
                                    lineHeight: '1.5',
                                    margin: '20px auto',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                }}
                                >
                                <i className="fas fa-exclamation-triangle" style={{ fontSize: '20px', marginTop: '3px' }}>
                                </i>
                                <div style={{width:'100%', display: 'flex',
                                    alignItems: 'center', justifyContent:'center', flexDirection:'column'}}>
                                    <strong style={{fontWeight: 600}} >Hold Tight!</strong>
                                    <p style={{ marginTop: '8px' }}>
                                    Our server is currently unavailable due to scheduled maintenance.<br/> We appreciate your understanding and expect to be back online within 48 hours.
                                    </p>
                                </div>
                            </div> */}
                            <div className="singin_form">
                                <div className="main_logo">
                                    {
                                        agencyId === 236 ? (
                                            <img className="login-page-logo" src={process.env.REACT_APP_CDN_LINK + "assets/images/releases/1.0.0/pluto-white-logo.png"} alt="Logo" loading="lazy" />
                                        ) : (
                                            <img className="login-page-logo" src={pageInfo.logo} alt="Logo" loading="lazy" />
                                        )
                                    }
                                </div>
                                <div className="account_text" style={{ color: pageInfo.agencyTextColor }}>
                                    <p>Don’t Have an Account? <Link 
                                    to={trialAgencyIds.includes(agencyId) 
                                        ? "/trial/get-started" 
                                        : "/paid/get-started"}
                                    >Sign Up</Link></p>
                                </div>
                                {
                                    typeof error.message != 'undefined' &&
                                    <div className="error_wrapper">
                                        <p className="text-danger">{error.message}</p>
                                    </div>
                                }

                                <form className="row login_form" 
                                 onSubmit={(e) => handleSubmit(e)}
                                >
                                    <div className="input-field login_form_input col s12">
                                        <input placeholder="Enter Your Email Address" id="email" type="email" required={'required'}
                                            onChange={(e) => {
                                                setError({});
                                                setEmail(e.target.value);
                                            }} value={email}
                                            className="validate" />
                                        <label htmlFor="email" className="active" style={{ color: pageInfo.agencyTextColor }}>Email Address</label>
                                        {
                                            typeof error.email !== 'undefined' &&
                                            <span className="text-danger">{error.email}</span>
                                        }
                                    </div>
                                    <div className="input-field login_form_input col s12 mb-1 ">
                                        <input required={'required'} placeholder="Enter password" id="password" type={textTypeChange ? 'text' : 'password'}
                                            onChange={(e) => setPassword(e.target.value)} value={password}
                                            className="validate" />

                                        {
                                            textTypeChange && <span className="visible__span" onClick={() => setTextTypeChange(!textTypeChange)}><VisibilityIcon /></span>
                                        }
                                        {
                                            !textTypeChange && <span className="visible__span" onClick={() => setTextTypeChange(!textTypeChange)}><VisibilityOff /></span>
                                        }

                                        <label style={{ color: pageInfo.agencyTextColor }} htmlFor="password" className="active">Password</label>
                                        {
                                            typeof error.password !== 'undefined' &&
                                            <span className="text-danger">{error.password}</span>
                                        }
                                    </div>
                                    <div action="#" className="check_box remember-pass" style={{marginBottom: 12}}>
                                        <label style={{ color: pageInfo.agencyTextColor }}>
                                            <input type="checkbox" className="filled-in" />
                                            <span style={{ color: pageInfo.agencyTextColor }}>Remember me</span>
                                        </label>
                                        <Link style={{ color: pageInfo.agencyTextColor }} to="/password-reset">Forget Password?</Link>
                                    </div>

                                    <div style={{marginBottom: 12}}>
                                        <FormControlLabel
                                        control={
                                            <Checkbox
                                                size={"small"}
                                                className={classes.checkbox}
                                                checked={isPolicyAndConditionChecked}
                                                onChange={() => {
                                                    setIsPolicyAndConditionChecked(
                                                    (prevChecked) => !prevChecked
                                                    );
                                                    if (errors.isPolicyAndConditionChecked) {
                                                    setErrors((prevState) => ({
                                                        ...prevState,
                                                        isPolicyAndConditionChecked: "",
                                                    }));
                                                    }
                                                }}
                                            />
                                        }
                                        label={
                                            <Typography
                                            style={{
                                                fontSize: "14px",
                                                color: pageInfo.agencyTextColor || "var(--dark_blue)",
                                            }}
                                            >
                                            I agree to the{" "}
                                            {pageInfo.termsAndConditions ? (
                                                <a 
                                                    className={classes.link} 
                                                    href={pageInfo.termsAndConditions}
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                Terms And Conditions
                                                </a>
                                            ) : (
                                                <a
                                                    className={classes.link}
                                                    href="/terms-and-conditions"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                Terms & Conditions
                                                </a>
                                            )}
                                            {" and "}
                                            {pageInfo.privacyPolicy ? (
                                                <a 
                                                    className={classes.link} 
                                                    href={pageInfo.privacyPolicy}
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                Privacy Policy
                                                </a>
                                            ) : (
                                                <a 
                                                    className={classes.link} 
                                                    href="/privacy-policy"
                                                    rel="noreferrer"
                                                    target="_blank"
                                                >
                                                Privacy Policy
                                                </a>
                                            )}
                                            </Typography>
                                        }
                                        />
                                        {errors.isPolicyAndConditionChecked && (
                                        <div className={classes.errorText}>
                                            {errors.isPolicyAndConditionChecked}
                                        </div>
                                        )}
                                    </div>
                                    <button 
                                     type='submit'
                                     className="login_btn" style={{ background: pageInfo.agencyAccentColor, cursor: 'pointer' }}>Log In</button>
                                </form>
                            </div>
                            <div className="licence_text">
                                <h6>{pageInfo.agencyName} {(new Date()).getFullYear()} - All Rights Reserved</h6>
                                {/* {
                                    (pageInfo.privacyPolicy !== null && pageInfo.privacyPolicy !== '') ?
                                        <a className="pr-4" href={pageInfo.privacyPolicy}>Privacy Policy</a> :
                                        <Link className="pr-4 okk" to="/privacy-policy">Privacy Policy</Link>
                                }

                                {
                                    (pageInfo.termsAndConditions !== null && pageInfo.termsAndConditions !== '') ?
                                        <a href={pageInfo.termsAndConditions}>Terms And Conditions</a> :
                                        <Link to="/terms-and-conditions">Terms And Conditions</Link>
                                } */}
                            </div>
                        </div>
                    </div>
                </div> :
                <OtpFormForLogin
                    pageLogo={pageInfo.logo}
                    accentColor={pageInfo.agencyAccentColor}
                    agencyThemeColor={pageInfo.agencyThemeColor}
                    agencyTextColor={pageInfo.agencyTextColor}
                    agencyName={pageInfo.agencyName}
                    email={email}
                    password={password}
                    agencyId={agencyId}
                />
            }
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.loginReducer.user,
        apiKey: state.loginReducer.apiKey,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        attemptLogin: (params, callback) => dispatch(attemptLogin(params, callback)),
        loginSuccess: (params) => dispatch(loginSuccess(params)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);